import { datadogRum } from '@datadog/browser-rum';
import portalEnvironment from '../Utils/baseURL';

const { environment: env, BaseUrl } = portalEnvironment;
const handleConfigsByEnviroment = () => {
  switch (env) {
    case 'DEV':
    case 'QA':
    case 'Stage':
      return {
        sessionReplaySampleRate: 10,
        sessionSampleRate: 100,
      };
    case 'Prod':
      return {
        sessionReplaySampleRate: 20,
        sessionSampleRate: 50,
      };
  }
};

const initDatadogRum = () => {
  const configsByEnviroment = handleConfigsByEnviroment();

  if (configsByEnviroment) {
    datadogRum.init({
      applicationId: 'a8f55d14-ac0e-456b-a481-75aa9c51243c',
      clientToken: 'pub5a8abeb0b988b444593c5a8120feffe5',
      site: 'datadoghq.com',
      service: 'podemorar-web',
      env,
      ...configsByEnviroment,
      allowedTracingUrls: [(url) => url.startsWith(BaseUrl)],
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.getGlobalContext;
    datadogRum.startSessionReplayRecording();
  }
};

const stopDatadogRum = () => {
  datadogRum.stopSession();
  datadogRum.removeUser();
};

export { initDatadogRum, stopDatadogRum };
